import 'assets/favicon.ico';
import { IApp } from 'interfaces/base';
import bridge from 'lib/bridge';
import { history } from 'lib/history';
import { loadLocale } from 'lib/moment';
import { observer } from 'mobx-react';
import Pages from 'pages';
import React from 'react';
import { Router } from 'react-router-dom';
import { sentryExceptionHandler } from 'sentry';
import themeStore from 'store/theme';
import { GlobalStyle } from 'style/global-style';
import { ThemeProvider } from 'styled-components';
import { Normalize } from 'styled-normalize';
import { configEnv } from 'util/config-file';
import VButton from './components/vkyc/v-button';
import VModal from './components/vkyc/v-modal';
import i18n from './i18n';
import { eventTrack } from './lib/event-track';

@observer
class App extends React.Component<{}, IApp> {
  static getDerivedStateFromError(error: any) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return <div>Opps! Something went wrong.</div>;
  }
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null, eventId: null };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('fetal error', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    sentryExceptionHandler.call(this, error, errorInfo);
  }
  async componentDidMount() {
    loadLocale();
    configEnv.init();
    eventTrack.init();
  }
  render() {
    if (this.state.errorInfo) {
      return (
        <VModal
          type="error"
          show={true}
          width={'auto'}
          title={i18n.t('common.SORRY')}
          text={navigator.onLine ? 'Fatal Error Happens.' : 'Your network is disconnected.'}
          details={this.state.eventId}
          footer={
            bridge.isWebView() && (
              <VButton status="success" onClick={bridge.closeSDK}>
                {i18n.t('common.ok')}
              </VButton>
            )
          }
        />
      );
    } else {
      return (
        <ThemeProvider theme={{ ...themeStore.getData(), ...bridge.mediaQuery }}>
          <GlobalStyle />
          <Normalize />
          <Router history={history}>
            <Pages />
          </Router>
        </ThemeProvider>
      );
    }
  }
}

const AppHot =
  process.env.NODE_ENV !== 'production' ? require('react-hot-loader/root').hot(App) : App;

export default AppHot;
